import { render } from "./TextInput.vue?vue&type=template&id=132da94d&scoped=true"
import script from "./TextInput.vue?vue&type=script&lang=js"
export * from "./TextInput.vue?vue&type=script&lang=js"

import "./TextInput.vue?vue&type=style&index=0&id=132da94d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-132da94d"

export default script